a.link-color{cursor:pointer;display:block;color:var(--text-link, #175CFF)}a.link-color i.fa-folder{color:var(--legacy-icon-color, #bcc6cc);font-size:1.875rem}
/*# sourceMappingURL=shared-drive-members-cell-viewer.component-45NPBRVW.css.map */
